import React, { Component } from "react"
import { Segment } from "semantic-ui-react"
import { connect } from "react-redux"
import CheckSvg from "../../assets/images/green_check_icon.svg"
import ReactSVG from "react-svg"
import { withTranslation } from "react-i18next"
import { CURRENT_FLEET } from "../../constants/application"
import { SUCCESS } from "../../constants/notification"
import CustomNotification from "../shared/CustomNotification"
import MiniLoader from "../shared/MiniLoader"

class VehicleTelematicsWidget extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show_loader: false
    }
  }

  connectToTelematics = () => {
    this.setState({ show_loader: true })
    this.props.dispatch({
      type: "GET_TELEMACTICS_CONNECT_LINK",
      callback: this.afterSuccess
    })
  }

  afterSuccess = (message, response) => {
    const { t } = this.props
    this.setState({ show_loader: false })
    if (message == SUCCESS) {
      sessionStorage.removeItem(CURRENT_FLEET)
      window.open(response["success"], "_blank")
    } else {
      CustomNotification("danger", t("notificationErrorTitle"), response)
    }
  }

  disconnectToTelematics = (fleet_id) => {
    const { t } = this.props
    const confirmed = window.confirm(t("diconnectConfirmationMessageLabel"))
    if (confirmed) {
      this.props.dispatch({
        type: "DISCONNECT_TO_TSP_PROVIDER",
        payload: { data: fleet_id },
        callback: this.afterSuccessfullyDisconnected
      })
    }
  }

  afterSuccessfullyDisconnected = (message, response) => {
    const { fleet, t } = this.props
    console.log(message, response)
    if (message == SUCCESS) {
      const fleet_id = fleet.id
      sessionStorage.removeItem(CURRENT_FLEET)
      this.props.dispatch({
        type: "FLEET_LOAD_SAGA",
        payload: { fleetId: fleet_id }
      })
      CustomNotification("success", t("notificationSuccessTitle"), t("disconnectedSuccessfully"))
    } else {
      CustomNotification("danger", t("notificationErrorTitle"), t("notificationErrorTitle"))
    }
  }

  render() {
    const { fleet, t } = this.props
    const { show_loader } = this.state
    return (
      <Segment style={{ marginTop: "60px" }}>
        {!fleet.tsp_fleet ? (
          <>
            <div className="telematics-frame">
              <div className="header telematics-header">{t("connectToTelematicsLabel")}</div>
              <div className="telematics-desc">{t("connectToTelematicsDescNormalLabel")}</div>
            </div>

            <div className="connet-to-telematics-btn">
              <div className="btn-wrapper">
                <div className="btn-text" onClick={() => this.connectToTelematics()}>
                  {show_loader ? <MiniLoader inverted={true} /> : t("connectTelemactisBtn")}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="telematics-frame">
              <div className="header telematics-header margin-top-15">
                {t("connectedToTelemacticsLabel")}
              </div>
              <div className="telematics-desc">{t("connectedToTelemacticsDescLabel")}</div>
            </div>

            <div className="telematics-connected-badge">
              <ReactSVG src={CheckSvg} className="icon" />
              <div className="text">Connected</div>
            </div>

            {/* <div className="disconnect-telematic-link-frame">
              <div
                className="text"
                onClick={() => this.disconnectToTelematics(fleet?.tsp_fleet.ext_fleet_id)}
              >
                {t("DisconnectTelematicsLink")}
                <MiniLoader inverted={true} />
              </div>
            </div> */}
          </>
        )}
      </Segment>
    )
  }
}

const mapStateToProps = (state) => ({
  fleet: state.application.fleetSessionData || state.fleets.fleet
})

export default connect(mapStateToProps)(withTranslation("vehicle")(VehicleTelematicsWidget))
